import React from 'react'
import styled from 'styled-components'
import Colors from '../assets/styles/Colors'
import BottomClouds from '../assets/icons/JSX/BottomClouds'
import FranIllustration from '../assets/icons/JSX/FranIllustration'
import Responsive from '../assets/config/Responsive'
import { useNavigate } from 'react-router-dom'

const EmptySreen: React.FC<{
  bigText?: string
  smallDescription?: string
  buttonText?: string
  buttonUrl?: string
  styles?: React.CSSProperties
}> = ({ bigText, smallDescription, buttonText, buttonUrl, styles }) => {
  // react router navigate for routing
  const navigate = useNavigate()
  return (
    <Wrapper style={styles}>
      <MessageBox>
        <h1>{bigText}</h1>
        <p>{smallDescription}</p>
        <button onClick={() => navigate(`${buttonUrl}`)}>{buttonText}</button>
      </MessageBox>
      <BottomCloudsStyle />
      <FranIllustrationStyle />
    </Wrapper>
  )
}

// styles
const FranIllustrationStyle = styled(FranIllustration)`
  position: absolute;
  right: 0;
  bottom: 0;
  height: 50vh;
  width: fit-content;
  ${Responsive.laptop} {
    height: 40vh;
  }
  ${Responsive.tablet} {
    height: 40vh;
  }
  ${Responsive.mobile} {
    height: 30vh;
    right: -25px;
  }
`
const BottomCloudsStyle = styled(BottomClouds)`
  position: absolute;
  left: 56px;
  bottom: 0;
  ${Responsive.tablet} {
  }
  ${Responsive.mobile} {
    left: 0;
    height: 5vh;
    width: fit-content;
  }
`
const MessageBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 3;
  /* large title  h1*/
  h1 {
    font-size: 36px;
    text-transform: capitalize;
    color: ${Colors.primaryBlack};
  }

  /* small text p*/
  p {
    color: ${Colors.primaryGrey};
    font-size: 18px;
  }

  /* button */
  button {
    width: 260px;
    height: 64px;
    border-radius: 4px;
    background-color: ${Colors.primaryRed};
    outline: none;
    border: 0px;
    color: ${Colors.white};
    font-size: 18px;
    margin-top: 65px;
  }

  /* responsive */
  ${Responsive.mobile} {
    justify-content: start;
    margin-top: 50px;
    /* large titile h1 */
    h1 {
      font-size: 18px;
      text-align: center;
    }
    /* description text p */
    p {
      font-size: 14px;
      text-align: center;
      margin-top: 5px;
    }
    /* calculation btn */
    button {
      width: 220px;
      height: 48px;
      font-size: 14px;
      margin-top: 48px;
    }
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  height: calc(100vh - 229px);
  width: 100%;
  background-color: ${Colors.backgroundGrey};
  position: relative;
  ${Responsive.tablet} {
    height: calc(100vh - 65px);
  }
  ${Responsive.mobile} {
    height: calc(100vh - 65px);
  }
`

export default EmptySreen
